/**
 * Tax – Declaration transactions modal (VAT returns list + create forms)
 */

export default {
  declarationTransactionsModal: {
    listViewTitle: "Transactions List",
    createViewTitle: "Add Transaction",
    switchToCreateLabel: "Add Transaction Form",
    switchToListLabel: "Back to Transactions List",
    altAddIcon: "Add",
    altBackIcon: "Back",
    altPlus: "Confirm amount",
    enterNumberAria: "Enter amount",
    filters: {
      transactionSearchLabel: "Transaction ID",
      transactionSearchPlaceholder: "Search by transaction ID",
      heading: "Filters:",
      monthA11y: "Month",
      monthNotSelected: "-",
      applyFilters: "Apply filters",
      clearFilters: "Clear filters",
    },
    columns: {
      index: "№",
      transactionId: "Transaction ID",
      date: "Date",
      transactionType: "Transaction type",
      currency: "Currency",
      amountWithTax: "Transaction amount (with tax)",
      taxRate: "Tax rate",
      taxAmount: "Tax amount",
      actionsMenuEdit: "Edit Amount Transaction",
      actionsMenuClone: "Clone transaction",
      actionsMenuDelete: "Delete transaction",
    },
    deleteConfirmTitle: "Delete transaction?",
    deleteConfirmDescription:
      "Are you sure you want to delete transaction {{transactionId}}? This action cannot be undone.",
    create: {
      dataStructureLabel: "Select the data structure to fill in.",
      structureGoods: "Goods",
      structureDigital: "Digital",
      submit: "Submit",
    },
    validation: {
      vatInvoiceNumberRequired: "VAT invoice number is required.",
      transactionAmountRequired: "Transaction amount is required.",
      transactionDateRequired: "Transaction date is required.",
      departureCountryRequired: "Departure country is required.",
      arrivalCountryRequired: "Arrival country is required.",
    },
    forms: {
      requiredFields: "Required fields",
      additionalFields: "Additional fields",
      transactionDate: "Transaction date",
      selectDate: "Select a date",
      transactionAmountWithTax: "Transaction amount (with tax)",
      enterTransactionAmountWithTax: "Enter transaction amount (with tax)",
      currency: "Currency",
      currencyPlaceholder: "Currency",
      departureCountry: "Departure country",
      enterDepartureCountry: "Enter departure country",
      arrivalCountry: "Arrival country",
      enterArrivalCountry: "Enter arrival country",
      buyerVatNumber: "Buyer VAT number",
      enterBuyerVatNumber: "Enter buyer VAT number",
      vatInvoiceNumber: "VAT invoice number",
      enterVatInvoiceNumber: "Enter VAT invoice number",
      invoiceDate: "Invoice date",
      transactionId: "Transaction ID",
      enterTransactionId: "Enter transaction ID",
      orderId: "Order ID",
      enterOrderId: "Enter order ID",
      parentTransactionId: "Parent transaction ID",
      enterParentTransactionId: "Enter parent transaction ID",
      shipmentFee: "Shipment fee",
      enterShipmentFee: "Enter shipment fee",
      departureZip: "Departure ZIP",
      enterDepartureZip: "Enter departure ZIP",
      departureState: "Departure state",
      enterDepartureState: "Enter departure state",
      departureCity: "Departure city",
      enterDepartureCity: "Enter departure city",
      departureAddressLine: "Departure address line",
      enterDepartureAddressLine: "Enter departure address line",
      arrivalZip: "Arrival ZIP",
      enterArrivalZip: "Enter arrival ZIP",
      arrivalState: "Arrival state",
      enterArrivalState: "Enter arrival state",
      arrivalCity: "Arrival city",
      enterArrivalCity: "Enter arrival city",
      arrivalAddressLine: "Arrival address line",
      enterArrivalAddressLine: "Enter arrival address line",
      paymentDateTime: "Payment date and time",
      goodCode: "Product code",
      enterGoodCode: "Enter product code",
      itemDescription: "Item description",
      enterItemDescription: "Enter item description",
      quantity: "Quantity",
      enterQuantity: "Enter quantity",
      buyerName: "Buyer name",
      enterBuyerName: "Enter buyer name",
      buyerId: "Buyer ID",
      enterBuyerId: "Enter buyer ID",
      deemed: "Deemed supply",
      billingAddressCountry: "Billing address country",
      enterBillingAddressCountry: "Enter billing address country",
      billingAddressZip: "Billing address ZIP",
      enterBillingAddressZip: "Enter billing address ZIP",
      billingState: "Billing state",
      enterBillingState: "Enter billing state",
      billingCity: "Billing city",
      enterBillingCity: "Enter billing city",
      billingAddressLine: "Billing address line",
      enterBillingAddressLine: "Enter billing address line",
      paymentMethodCountry: "Payment method country",
      enterPaymentMethodCountry: "Enter payment method country",
      serviceCode: "Service code",
      enterServiceCode: "Enter service code",
      buyerIpAddress: "Buyer IP address",
      enterBuyerIpAddress: "Enter buyer IP address",
    },
    /** Labels when creating a sales tax return transaction (VAT wording replaced with Sales TAX). */
    salesTaxForms: {
      requiredFields: "Required fields (Sales TAX)",
      additionalFields: "Additional fields (Sales TAX)",
      buyerVatNumber: "Buyer Sales TAX reference",
      enterBuyerVatNumber: "Enter buyer Sales TAX reference",
      vatInvoiceNumber: "Sales TAX document number",
      enterVatInvoiceNumber: "Enter Sales TAX document number",
    },
  },
};
